import { render, staticRenderFns } from "./MallDomainSelector.vue?vue&type=template&id=70326014&"
import script from "./MallDomainSelector.vue?vue&type=script&lang=ts&"
export * from "./MallDomainSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports